import { Box, Grid, GridSize, Typography } from "@mui/material";
import {
  ItemIconBox,
  LowerContainer,
  MemberInfoContainer,
  MemberInfoField,
  PatientDetailsValue,
  patientNameContainer,
  patientNameTypo,
  styles,
} from "../style";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { displayFlex } from "../../../styles/mui/styles/display";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import { PatientHeaderFormProps } from ".";
export const PatientNameGrid = (patientName: string) => {
  return (
    <Grid sx={styles.container}>
      <Typography
        variant="h2"
        fontWeight={fontWeight.Weight[7]}
        lineHeight={"1.8rem"}
        sx={patientNameTypo}
        color={colors.fonts[18]}
      >
        <Box style={styles.lineItem}>{patientName}</Box>
      </Typography>
    </Grid>
  );
};

const MemberInfo: React.FC<PatientHeaderFormProps> = ({ getValues }: PatientHeaderFormProps)=> {
  const fieldRender = (
    label: string,
    xs: GridSize,
    value: string | number | null,
    icon?: React.ReactNode
  ) => {
    return (
      <Grid size={xs} sx={MemberInfoField}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Weight[3]}
          color={colors.fonts[2]}
        >
          {label}
        </Typography>
        <Box sx={displayFlex}>
          {icon && value ? <Box sx={ItemIconBox}>{icon}</Box> : ""}
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[5]}
            color={colors.fonts[4]}
            sx={PatientDetailsValue}
          >
            {value}
          </Typography>
        </Box>
      </Grid>
    );
  };

  return (
    <Grid container wrap="nowrap" columnSpacing={0.5}>
      <Grid size="auto" sx={patientNameContainer}>
        {PatientNameGrid(getValues("patientName"))}
      </Grid>
      <Grid size="grow">
        <Grid container size={"grow"}>
          <Grid size={12}>
            <Grid container sx={MemberInfoContainer}>
              {fieldRender(
                "DOB",
                "auto",
                formatDate(
                  getValues("memberInfo.dateOfBirth"),
                  DateFormats.MM_DD_YYYY,
                  true,
                )
              )}
              {fieldRender("Gender", 0.1, getValues("memberInfo.gender"))}
              {fieldRender(
                "Prefix",
                "auto",
                getValues("memberInfo.subscriberPrefix")
              )}
              {fieldRender(
                "Subscriber ID:",
                "auto",
                getValues("memberInfo.subscriberId")
              )}
              {fieldRender(
                "Group ID:",
                "auto",
                getValues("memberInfo.groupPlanId")
              )}
              {fieldRender(
                "Relationship:",
                "auto",
                getValues("memberInfo.relationshipType")
              )}
              {fieldRender(
                "MBI:",
                "auto",
                getValues("memberInfo.medicareBeneficiaryIdentifier")
              )}
              {fieldRender(
                "Language:",
                "auto",
                getValues("memberInfo.languageName")
              )}
              {fieldRender(
                "Alt Accommodation:",
                "auto",
                getValues("memberInfo.accommodationName")
              )}
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container size={"grow"} sx={LowerContainer}>
              {fieldRender(
                "Health Plan:",
                1.8,
                getValues("memberInfo.healthPlan")
              )}
              {fieldRender(
                "Benefit Plan:",
                1.2,
                getValues("memberInfo.benefitPlan")
              )}
              {fieldRender("Product:", 1.5, getValues("memberInfo.product"))}
              {fieldRender(
                "State of Issuance:",
                1.5,
                getValues("memberInfo.insuranceState")
              )}
              {fieldRender(
                "Contract ID-PBP:",
                1.5,
                getValues("memberInfo.contractIdPbp")
              )}
              {fieldRender(
                "Eligibility Dates:",
                1.7,
                formatDate(
                  getValues("memberInfo.effectiveDate"),
                  DateFormats.MM_DD_YYYY
                ) +
                  " - " +
                  formatDate(
                    getValues("memberInfo.effectiveThrough"),
                    DateFormats.MM_DD_YYYY
                  )
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MemberInfo;
